import ReopeningTool from "../../../../src/components/marketing/reopeningTool";
import * as React from 'react';
export default {
  ReopeningTool,
  React
};